"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordUpdateStatus = exports.PasswordChangeStatus = void 0;
var PasswordChangeStatus;
(function (PasswordChangeStatus) {
    PasswordChangeStatus[PasswordChangeStatus["Error"] = 0] = "Error";
    PasswordChangeStatus[PasswordChangeStatus["Success"] = 1] = "Success";
    PasswordChangeStatus[PasswordChangeStatus["TokenExpired"] = 2] = "TokenExpired";
})(PasswordChangeStatus || (exports.PasswordChangeStatus = PasswordChangeStatus = {}));
var PasswordUpdateStatus;
(function (PasswordUpdateStatus) {
    PasswordUpdateStatus[PasswordUpdateStatus["Error"] = 0] = "Error";
    PasswordUpdateStatus[PasswordUpdateStatus["Success"] = 1] = "Success";
    PasswordUpdateStatus[PasswordUpdateStatus["NoChange"] = 2] = "NoChange";
})(PasswordUpdateStatus || (exports.PasswordUpdateStatus = PasswordUpdateStatus = {}));
//# sourceMappingURL=password.js.map